import { forwardRef } from 'react';
import './Container.scss';

const Container = forwardRef(
  ({ children, size = 'lg', className = '', ...props }, ref) => {
    const classes = `container container-${size} ${className}`.trim();

    return (
      <div ref={ref} className={classes} {...props}>
        {children}
      </div>
    );
  }
);

Container.displayName = 'Container';

export default Container;
